// Constants
import { RELOADED_VARIANTS } from '@kubit/web-ui-product-components';
import { LinkSizesEnum } from '../../../designSystem/reloaded/commons/components/link/variants';
const DETAIL_CONSTANTS = {
    BUTTON: {
        type: RELOADED_VARIANTS.ButtonVariantType.PRIMARY_GHOST,
        size: RELOADED_VARIANTS.ButtonSizeType.EXTRA_SMALL,
    },
    LINK: {
        type: RELOADED_VARIANTS.LinkVariantType.PRIMARY,
        size: LinkSizesEnum.SMALL,
    },
    BUTTON_ICON: {
        type: RELOADED_VARIANTS.ButtonVariantType.ICON_PRIMARY,
        size: RELOADED_VARIANTS.ButtonSizeType.EXTRA_SMALL,
    },
    LABEL_BUTTON_ICON: {
        type: RELOADED_VARIANTS.ButtonVariantType.PRIMARY_GHOST,
        size: RELOADED_VARIANTS.ButtonSizeType.EXTRA_SMALL,
        iconConfiguration: {
            icon: 'icon_symbols_information-in-a-circle',
            height: '24px',
            width: '24px',
        },
    },
};
export { DETAIL_CONSTANTS };
//# sourceMappingURL=detail.constants.js.map